import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const authModalAtom = atom(false)
export const showReleaseDialogAtom = atom(false)
export const showFeedbackModalAtom = atom(false)
export const showClientTsnCsModalAtom = atom(false)

// Stores the accepted flag directly in localStorage
export const tsncsAcceptedAtom = atomWithStorage<boolean>('tsncs_accepted', false)

// Derives modal visibility based on acceptance
export const showTsnCsModalAtom = atom((get) => !get(tsncsAcceptedAtom))

authModalAtom.debugLabel = 'authModalAtom'
showReleaseDialogAtom.debugLabel = 'showReleaseDialogAtom'
showFeedbackModalAtom.debugLabel = 'showFeedbackModalAtom'
showClientTsnCsModalAtom.debugLabel = 'showClientTsnCsModalAtom'
tsncsAcceptedAtom.debugLabel = 'tsncsAcceptedAtom'
showTsnCsModalAtom.debugLabel = 'showTsnCsModalAtom'
